import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';

import { CheckMotoService } from '../services/check-moto.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';
import { ProfissionalService } from '../services/profissional.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';



@Component({
  selector: 'app-checklist-moto',
  templateUrl: './checklist-moto.component.html',
  styleUrls: ['./checklist-moto.component.css'],
	animations: [loadingFade, modal, alert]
})
export class ChecklistMotoComponent implements OnInit {

    //Id do menu da tb_menu
    public menu_id = 121; //checklist	

    public loading = false;
	public checklists = [];
	public veiculos = [];
	public unidades = [];
	public clientes = [];
	public tipoVeiculo = [];
	public profissionais = [];
	public periodos = [{ periodo: 'D', periodo_nome: 'Diurno'}, { periodo: 'N', periodo_nome: 'Noturno'}];
	public situacoes = [{ situacao: '1', situacao_nome: 'Ativo'}, { situacao: '0', situacao_nome: 'Inativo'}];
	public perfil = this.authSvc.getPerfil();
	
	public formFiltro: FormGroup;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idChecklistApagar = null;

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;
	public usuario_exibir_regiao;
	
	constructor(private fb: FormBuilder,
				private checkMotoSvc: CheckMotoService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private veiculoSvc: VeiculoService,
				private authSvc: AuthService,
				private route: ActivatedRoute,
				private router: Router,				
				private profissionalSvc: ProfissionalService ,
				private especialidadeVeiculoSvc: EspecialidadeVeiculoService,
				private excelSvc: ExcelService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  


		//Verifica perfil de Acesso
		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {
		
			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.pegaChecklistsRegiao();
			}else{
				this.pegaChecklists();
			}
	
		}).catch((err) => {
		console.log(err);scrollBy
		});  		


		this.pegaChecklists();
		this.criaFiltro();
	}
	
	criaFiltro() {
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaVeiculos();
		this.pegaEspecialidadesVeiculo()
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			check_moto_turno___periodo:null,
			check_moto_status___status:null,
			check_moto_data___data_i: null,
			check_moto_data___data_f: null,
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

		let campos_data = ['check_moto_data___data_i', 'check_moto_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}

		this.route.params.subscribe( params => {

			if(params.id){

				let splitF = params.id.split("&");

				let loCliente_id = null;
				let loUnidade_id = null;
				let loVeiculo_id = null;
				let loTipoVeiculo_id = null;
				let loPeriodo_id = null;
				let loData_i = "";
				let loData_f = "";
				let loProfissional_id = null;

				//this.showFilter = false;

				for (var i = 0; i < splitF.length; i++) {

					var loSplitValor = splitF[i].split("=");

					switch(loSplitValor[0]) { 
						case "cliente_id___cliente": { 

							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loCliente_id = parseInt(loSplitValor[1]);
								this.pegaUnidadesFiltro(loSplitValor[1]);
							}
						   break; 

						} 
						case "unidade_id___unidade": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loUnidade_id = parseInt(loSplitValor[1]);
								this.pegaVeiculosEProfissionalFiltro(loUnidade_id,loCliente_id);
							}

						  break; 
						}
						case "veiculo_id___veiculo": { 
							this.showFilter = false;
							if(loSplitValor[1] !== "null"){
						   		loVeiculo_id = parseInt(loSplitValor[1]);
							}
						   break; 
						} 
						case "especialidade_veiculo_id___veiculo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
								loTipoVeiculo_id = parseInt(loSplitValor[1]);
							}
							break; 
						}  
						case "check_moto_turno___periodo": { 
							if(loSplitValor[1] !== "null"){
								this.showFilter = false;
						   		loPeriodo_id = loSplitValor[1];
							}
						   break; 
						}     
						case "check_moto_data___data_i": { 
							this.showFilter = false;
							if(loSplitValor[1] !== "null"){
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "check_moto_data___data_f": { 
							this.showFilter = false;
							if(loSplitValor[1] !== "null"){
								let splitDate1 = loSplitValor[1].split("-");
								if(splitDate1){
									loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
								}
							}
						   break; 
						}      
						case "profissional_id___profissional": { 
							this.showFilter = false;
							if(loSplitValor[1] !== "null"){
						   		loProfissional_id =  parseInt(loSplitValor[1]);
							}
						   break; 
						}                                                      
					 }

				}
				this.preencheForm({
					cliente_id___cliente: loCliente_id,
					unidade_id___unidade: loUnidade_id,
					veiculo_id___veiculo: loVeiculo_id,
					check_moto_turno___periodo: loPeriodo_id,
					check_moto_status___status: null, // nao esta sendo usado?
					check_moto_data___data_i: loData_i,
					check_moto_data___data_f: loData_f,
					especialidade_veiculo_id___veiculo: loTipoVeiculo_id,
					profissional_id___profissional: loProfissional_id									

				});
				this.filtra();

			}

		});

	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
  	}

	pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
			this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
				this.unidades = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
		}
	}

	pegaChecklists() {
		this.checklists = [];
		this.loading = true;

		this.checkMotoSvc.getCheckMotoByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.checklists = data;
			this.count = this.checklists.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	pegaChecklistsRegiao() {
		this.checklists = [];
		this.loading = true;

		this.checkMotoSvc.getCheckMotoByRegiao(this.authSvc.getUsuarioId()).then((data: any) => {
			this.checklists = data;
			this.count = this.checklists.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	onChangeCliente(evento){

		if(typeof evento === 'undefined'){
			return "";
		}else{    		

			this.formFiltro.controls.unidade_id___unidade.setValue(null);
			this.formFiltro.controls.veiculo_id___veiculo.setValue(null);
			this.loading = true;

			this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
				this.unidades = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});

		}
	}

	onChangeVeiculoUnidade(e){

		if(typeof e === 'undefined'){
			return "";
		}else{    	

		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"moto").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}

	pegaVeiculosEProfissionalFiltro(unidade_id,cliente_id){

		if(typeof unidade_id === 'undefined'){
			return "";
		}else{
		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: unidade_id,
				cliente_id: cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}

	pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(cliente_id,unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	
	
	pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }		

	pegaVeiculos(){
		this.veiculoSvc.getMotos(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroChecklistPipe().transform(this.checklists, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

	perguntaApagar(id) {
		this.modalApagar = 'shown';
		this.idChecklistApagar = id;
	}

	cancelaApagar() {
		this.modalApagar = 'hidden';
	}

	apagaDespesa() {
		this.modalApagar = 'hidden';
		this.loading = true;
		if(this.authSvc.getPerfil() == 2){
			this.checkMotoSvc.apagaCheckMotoAdmin(this.idChecklistApagar).then((data) => {
				this.mostraMsg('Checklist apagada com sucesso.', 'alert-success');
				this.pegaChecklists();
			}).catch((err) => {
				console.log(err);
				this.mostraMsg('Problema ao apagar checklist.', 'alert-danger');
				this.loading = false;
			});
		}
		else{
			this.checkMotoSvc.apagaCheckMoto(this.idChecklistApagar).then((data) => {
				this.mostraMsg('Checklist apagada com sucesso.', 'alert-success');
				this.pegaChecklists();
			}).catch((err) => {
				console.log(err);
				this.mostraMsg('Problema ao apagar checklist.', 'alert-danger');
				this.loading = false;
			});
		}
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.checklists;
		}

		console.log("[dadosFiltrados]" , this.dadosFiltrados);

		for(let index in this.dadosFiltrados){
			data[index] = {
				'Central': this.dadosFiltrados[index].cliente.cliente_nome,
				'Unidade': this.dadosFiltrados[index].unidade.unidade_nome,
				'Data do Turno': moment(this.dadosFiltrados[index].check_moto_data).format('DD/MM/YYYY'),
				'Periodo': this.dadosFiltrados[index].check_moto_turno == 'D' ? 'Diurno' : 'Noturno',
				'Veículo': this.dadosFiltrados[index].veiculo.veiculo_placa,
				'Quilometragem': this.mascaraKm(this.dadosFiltrados[index].check_moto_quilometragem),
				'Nome': this.dadosFiltrados[index].veiculo.veiculo_numero,
				'Profissional': this.dadosFiltrados[index].profissional.profissional_nome,
				'Data/hora de gravação': this.dadosFiltrados[index].check_moto_registro? moment(this.dadosFiltrados[index].check_moto_registro).format('DD/MM/YYYY HH:mm:ss') : '',
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Checklists');
	}

	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	print(id){
		this.router.navigate(['home/checkmotoprint/' + id]);
	}

	calculaTempoExecucao(inicio, fim){
		if(inicio != null && fim != null){
			inicio = moment(inicio, 'YYYY-MM-DD HH:mm:ss')
			fim = moment(fim, 'YYYY-MM-DD HH:mm:ss')
			let tempo = moment.duration(fim.diff(inicio));
			return  tempo.minutes() + ' m ' + tempo.seconds() + ' s';
		}
		else{
			return null;
		}
		
	}

	deletado(flag){
		return flag == 'S' ? 'deletado' : '';
	}

	pegaEspecialidadesVeiculo() {
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculoIn('moto','especialidade_veiculo_nome').then((data: any[]) => {
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	onClickLimparCampos(){
		
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaVeiculos();
		this.pegaEspecialidadesVeiculo()
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			check_moto_turno___periodo:null,
			check_moto_status___status:null,
			check_moto_data___data_i: null,
			check_moto_data___data_f: null,
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

	  }


	  EditChecklistMoto(check_moto_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/checkmoto/edit/' + check_moto_id + params]);
	}


	VerChecklistMoto(check_moto_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		this.router.navigate(['home/checkmoto/ver/' + check_moto_id + params]);
	}

	
	mascaraKm(valor){

		if(valor != "" && valor != null){
			let sValor = valor.split(".");
			if(sValor[1] == "000"){
				return sValor[0];
			}else{
				return sValor[0] + sValor[1];
			}
		}else{
			return "";
		}

	  }

}
